<label *ngIf="label !== ''"
  >{{ label }}<span *ngIf="required" class="color-weak"> *</span></label
>
<div class="input-error {{ errorClass }}">
  <rr-icon name="octagon"></rr-icon>
  <span *ngIf="control.hasError('required')" i18n>This field is required</span>
  <span *ngIf="!control.hasError('required')" i18n
    >Your input is not valid</span
  >
</div>

<rr-btn
  class="space-between disabled-{{ disabled }} {{ errorClass }}"
  size="medium"
  type="secondary"
  iconEnd="chevron-down"
  (click)="toggleOptions($event.target)"
  (blur)="onTouched()"
  >{{ selectedName || "Select " + label }}</rr-btn
>

<div
  class="backdrop"
  (click)="checkValidation(); toggleOptions($event.target)"
  *ngIf="showOptions"
></div>
<div
  class="selectoptions {{ errorClass }}"
  *ngIf="showOptions"
  [style.width]="elementWidth"
>
  <div
    class="selectoption"
    *ngFor="let option of options"
    (click)="selectOption(option)"
  >
    <rr-icon *ngIf="option?.icon" [name]="option.icon"></rr-icon>
    {{ option[optionName] }}
  </div>
</div>
